import React, { Children } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Section } from '../components/Section';
export function Privacy() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-505" data-mp="3b8ba28l39gnz">
      <Navbar data-id="element-506" data-mp="3banz15p9kraj" />
      <main className="flex-grow" data-id="element-507" data-mp="3bae5j850g203">
        <Section className="pt-32 md:pt-48" data-id="element-508" data-mp="36hl16ldgevoj">
          <div className="max-w-4xl mx-auto" data-id="element-509" data-mp="36fruj62ucbgj">
            <h1 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-4" data-id="element-510" data-mp="3k8ggogigkb13">
              HiddenMatter Website Privacy Notice
            </h1>
            <p className="font-inter text-base text-black mb-8" data-id="element-511" data-mp="3fcizk7zdf0n9">
              Effective Date: 7 April 2026
            </p>
            <div className="space-y-8 font-inter text-base leading-relaxed text-black" data-id="element-512" data-mp="3p8m1bcqb8x9o">
              <p data-id="element-513" data-mp="1zteios1fmfdg">
                HiddenMatter, LLC ("HiddenMatter," "we," "our," or "us") values
                your privacy and the protection of information we collect that
                can be used to identify you or that we can link to or associate
                with a you ("Personal Data"). This Privacy Notice ("Notice")
                explains how we collect, store, use, share, transfer, delete,
                and otherwise process your Personal Data.
              </p>
              <p data-id="element-514" data-mp="q115r8m8e783">
                Please review this Notice carefully. To the extent permitted by
                law, by providing us your Personal Data or otherwise interacting
                with us, you are acknowledging this Notice. If you do not agree
                with our policies and practices, it is your choice not to use
                our Services or otherwise engage with us.
              </p>
              <div className="pt-4" data-id="element-515" data-mp="1dsgh1qvzjyvh">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-516" data-mp="1drdolej0lodg">
                  Purpose of this Privacy Notice
                </h2>
                <p data-id="element-517" data-mp="3fjjoy8ehqzcc">
                  This Notice describes the types of Personal Data that
                  HiddenMatter may collect or process, how we may use and
                  disclose that Personal Data, how you may exercise any rights
                  you may have regarding our processing of your Personal Data,
                  and how you can contact us if you would like to exercise them
                  or if you have any questions or concerns.
                </p>
                <p className="mt-4" data-id="element-518" data-mp="qt9djen3dcn2">
                  This Notice applies to Personal Data we collect or process
                  through online activities and services we offer as well as
                  when you contact us (collectively, "Services"). HiddenMatter
                  may provide you with a different privacy notice in certain
                  specific situations, in which case that privacy notice or
                  policy will apply to the Personal Data collected or processed
                  in that specific situation, rather than this one.
                </p>
                <p className="mt-4" data-id="element-519" data-mp="1jdhh3lb4ok5n">
                  We may collect or process Personal Data as a service provider
                  on behalf of our customers. In those instances, you should
                  consult the customer's applicable privacy notice or reach out
                  the customer to for information regarding how they process
                  your Personal Data.
                </p>
                <p className="mt-4" data-id="element-520" data-mp="1y43v1vh0j0pl">
                  If you provide us with Personal Data related to anyone other
                  than yourself, please note that you are responsible for
                  complying with all privacy and data protection laws prior to
                  providing that information to HiddenMatter (including
                  obtaining consent, if required).
                </p>
                <p className="mt-4" data-id="element-521" data-mp="11ca4ovkw0q75">
                  This Notice applies to the HiddenMatter website and related
                  online activities only. If you access or use the Huwey
                  organizational intelligence platform, your use of that
                  platform is governed by the Huwey Platform Privacy Notice. In
                  the event of any conflict between this Notice and the Huwey
                  Platform Privacy Notice with respect to the platform, the
                  Huwey Platform Privacy Notice controls.
                </p>
              </div>
              <div className="pt-4" data-id="element-522" data-mp="fjxpepid4vu2">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-523" data-mp="fkyyioftj895">
                  Personal Data Collected, Purposes, and Recipients
                </h2>
                <p data-id="element-524" data-mp="5l87iwqgvbdt">
                  We may collect or process your Personal Data when you (1)
                  engage with online activities and services we offer through
                  this and other of our websites, email, online channels,
                  including through social media, and otherwise; (2) interact
                  with our websites; (3) sign up for our newsletters or other
                  informational or marketing materials; (4) contact us through
                  phone, email, or otherwise; and/or (5) completing a survey or
                  other online questionnaire or form.
                </p>
                <h3 className="font-poppins font-normal text-lg text-black mt-6 mb-3" data-id="element-525" data-mp="2cajvj6qwg5xq">
                  Examples of the types of Personal Data we collect or process
                  (Personal Data that may be considered sensitive under some
                  data protection laws is noted with a "^")
                </h3>
                <div className="space-y-4" data-id="element-526" data-mp="1om922onj98jh">
                  <div data-id="element-527" data-mp="1tj95erszzx6w">
                    <p className="font-medium mb-2" data-id="element-528" data-mp="1thxtg4pefj4p">
                      Identity and contact information, such as:
                    </p>
                    <ul className="list-disc ml-6 space-y-1" data-id="element-529" data-mp="34yo35xt16t32">
                      <li data-id="element-530" data-mp="34yfqa5wwrnrv">first and last name or unique pseudonym</li>
                      <li data-id="element-531" data-mp="39wpluhmjoqe0">honorifics and titles, preferred form of address</li>
                      <li data-id="element-532" data-mp="2k93pf45sm4fu">employer / company</li>
                      <li data-id="element-533" data-mp="2k7sac86wda9f">email address</li>
                      <li data-id="element-534" data-mp="2fasdmnvxtjuz">postal address</li>
                      <li data-id="element-535" data-mp="2fa0ife695o58">phone number</li>
                      <li data-id="element-536" data-mp="2u7sutxgi5wf7">cookies and tracking IDs</li>
                    </ul>
                  </div>
                  <div data-id="element-537" data-mp="2p8q0b6y5f8lh">
                    <p className="font-medium mb-2" data-id="element-538" data-mp="2p8gcnq0ktdiy">
                      Video, Audio, and Recorded Information, such as:
                    </p>
                    <ul className="list-disc ml-6 space-y-1" data-id="element-539" data-mp="21h16fm5oic2f">
                      <li data-id="element-540" data-mp="1wl3r9j65jbr8">still images^</li>
                      <li data-id="element-541" data-mp="1wi7onhjczywg">video^</li>
                      <li data-id="element-542" data-mp="2b96voo4jqfdx">recordings of online events^</li>
                      <li data-id="element-543" data-mp="2barqmeurw0cb">
                        recordings of your interactions with our Services,
                        whether through email or otherwise
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-544" data-mp="1du2sow8y1i87">
                    <p className="font-medium mb-2" data-id="element-545" data-mp="1dsrmyqvxu0eg">
                      Technical or electronic network activity information, such
                      as:
                    </p>
                    <ul className="list-disc ml-6 space-y-1" data-id="element-546" data-mp="3u7whvolkilwa">
                      <li data-id="element-547" data-mp="3fiqio0mqcvoe">
                        Internet Protocol (IP) addresses (which may identify
                        your general geographic location or company)
                      </li>
                      <li data-id="element-548" data-mp="c207768dpqfb">browser type and browser language</li>
                      <li data-id="element-549" data-mp="c2jhc0rsfais">device type</li>
                      <li data-id="element-550" data-mp="h0uog3qp76xb">date and time you use our Services</li>
                      <li data-id="element-551" data-mp="h0bfhcj0zsvf">
                        Uniform Resource Locators, or URLs (i.e., website
                        addresses) visited prior to arriving at and after
                        leaving our Services
                      </li>
                      <li data-id="element-552" data-mp="2nr15agsb0xrf">
                        activity and online behavior while on our Services and
                        referring websites or applications, including forms and
                        other information submitted, videos watched, your clicks
                        on our site pages, search queries, browsing history,
                        etc.
                      </li>
                      <li data-id="element-553" data-mp="3afiww8fmvob3">usernames and passwords</li>
                    </ul>
                  </div>
                </div>
                <div className="space-y-4 mt-6" data-id="element-554" data-mp="35hzgb1vgqzfz">
                  <div data-id="element-555" data-mp="61t53jwzfdx9">
                    <p className="font-medium mb-2" data-id="element-556" data-mp="62cay29cybux">
                      Where do we get your Personal Data?
                    </p>
                    <ul className="list-disc ml-6 space-y-1" data-id="element-557" data-mp="20r4aynf2tt6">
                      <li data-id="element-558" data-mp="3ted9barmkco3">you directly</li>
                      <li data-id="element-559" data-mp="3td289ipkdj0o">
                        those you have authorized to provide Personal Data on
                        your behalf
                      </li>
                      <li data-id="element-560" data-mp="pq1zm0lzzvzx">your devices</li>
                      <li data-id="element-561" data-mp="prwhf61z37zs">our security systems (including CCTV)</li>
                      <li data-id="element-562" data-mp="kybhv9kqe5yh">
                        business partners and other third parties that assist us
                        in providing and improving our Services
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-563" data-mp="xb5pmvyqt0n9">
                    <p className="font-medium mb-2" data-id="element-564" data-mp="127w63kegly97">
                      Why do we process your Personal Data?
                    </p>
                    <ul className="list-disc ml-6 space-y-1" data-id="element-565" data-mp="16bkg09qkd5xm">
                      <li data-id="element-566" data-mp="1b9lz2unzp593">to provide you with our Services</li>
                      <li data-id="element-567" data-mp="1b79iaktyx0xm">to communicate with you</li>
                      <li data-id="element-568" data-mp="1g75dbukoti11">
                        to administer our relationship with your organization
                      </li>
                      <li data-id="element-569" data-mp="1kzox599yx9ea">to identify and authenticate you</li>
                      <li data-id="element-570" data-mp="1pwyl0khpld00">to detect security incidents</li>
                      <li data-id="element-571" data-mp="1tzljv5csry6p">
                        to protect against malicious, fraudulent, or illegal
                        activity
                      </li>
                      <li data-id="element-572" data-mp="1yz7z1kc6roi5">to ensure the appropriate use of our Services</li>
                      <li data-id="element-573" data-mp="1rj366m2xi2mr">to improve our Services</li>
                      <li data-id="element-574" data-mp="1wh4pn849o3yr">for short-term, transient use</li>
                      <li data-id="element-575" data-mp="1whmugt4zvqia">for administrative purposes</li>
                      <li data-id="element-576" data-mp="21fod5cyidnt8">for marketing, internal research, and development</li>
                      <li data-id="element-577" data-mp="266y0g6wl4f1y">for quality assurance</li>
                      <li data-id="element-578" data-mp="267pw1hq6mcs8">to comply with legal and regulatory obligations</li>
                    </ul>
                  </div>
                  <div data-id="element-579" data-mp="2aam96swydgos">
                    <p className="font-medium mb-2" data-id="element-580" data-mp="2f7mev2pw4hfd">
                      What are the Lawful or Legal Bases of Processing your
                      Personal Data?
                    </p>
                    <ul className="list-disc ml-6 space-y-1" data-id="element-581" data-mp="2k4v1pglzh9my">
                      <li data-id="element-582" data-mp="2p5aarvz8fuz4">for the purposes of our legitimate interests</li>
                      <li data-id="element-583" data-mp="ptgaswh8l45m">
                        in preparation for or to perform a contract with you
                      </li>
                      <li data-id="element-584" data-mp="usayabq5fgw2">
                        to comply with legal and regulatory obligations and to
                        establish, exercise, or defend our legal claims and
                        rights
                      </li>
                      <li data-id="element-585" data-mp="2z9haruldslay">
                        in circumstances where we have requested and received
                        consent and for other purposes that may be required or
                        allowed by law
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-586" data-mp="3mzbjbzyo3npe">
                    <p className="font-medium mb-2" data-id="element-587" data-mp="3mz1wgl8x5wnx">
                      Who may receive your Personal Data?
                    </p>
                    <ul className="list-disc ml-6 space-y-1" data-id="element-588" data-mp="3hydtd17f1pdc">
                      <li data-id="element-589" data-mp="3d1x4g4se76z7">HiddenMatter and our Affiliates</li>
                      <li data-id="element-590" data-mp="3d3hy7s6vulw0">your company / employer</li>
                      <li data-id="element-591" data-mp="26luwnsej1y9u">
                        individuals or entities that you designate or instruct
                        us to share your Personal Data with
                      </li>
                      <li data-id="element-592" data-mp="23477k5kvxg50">authorized representatives</li>
                      <li data-id="element-593" data-mp="2828nihn0kzc9">
                        third parties who assist with fraud prevention,
                        detection, and mitigation
                      </li>
                      <li data-id="element-594" data-mp="1u4k47e8li09b">
                        third parties who assist with our information technology
                        and security programs and our loss prevention programs
                      </li>
                      <li data-id="element-595" data-mp="1kathoew13zw9">HiddenMatter's lawyers, auditors, and consultants</li>
                      <li data-id="element-596" data-mp="1p4o07ezwe8tr">
                        partners that assist us in providing or improving our
                        Services or help us improve our marketing or
                        administration*
                      </li>
                    </ul>
                    <p className="mt-2 text-sm" data-id="element-597" data-mp="11etmywbo2i8z">
                      *In limited circumstances, recipients may include, (1) in
                      the event of a sale, assignment, merger, consolidation,
                      corporate reorganization, or transfer, to the buyer,
                      assignee, or transferee; and (2) government or regulatory
                      officials, law enforcement, courts, public authorities, or
                      others when permitted by this Notice or required by law.
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-4" data-id="element-598" data-mp="15ompq5tw3nd3">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-599" data-mp="15nl10yjyb2cw">
                  Personal Data of Children
                </h2>
                <p data-id="element-600" data-mp="1fefpm9ko6e1i">
                  HiddenMatter does not knowingly collect, maintain, disclose,
                  or otherwise process Personal Data from minors below the age
                  of 16 without the permission of such minor's parents or legal
                  guardians.
                </p>
              </div>
              <div className="pt-4" data-id="element-601" data-mp="1kgoht3ppxc2k">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-602" data-mp="3dxud0p0xv6fh">
                  Marketing
                </h2>
                <p data-id="element-603" data-mp="3iv2t8k2j10e3">
                  To the extent permitted by law, including with your consent
                  where required, we may use your contact details to contact you
                  to determine whether you would like to initiate a business
                  relationship with us or to send you marketing emails. If you
                  do not wish to receive such marketing emails, you may opt out
                  by declining to receive such emails when registering, in our
                  subsequent communications by following opt-out or unsubscribe
                  instructions included in the email, by contacting us, or at
                  other information collection points while using the Services.
                </p>
                <p className="mt-4" data-id="element-604" data-mp="o7z1uij0t9yd">
                  We do not "sell" your Personal Data or share it for the
                  purposes of cross-context behavioral (i.e., "targeted")
                  advertising or profiling nor do we process your sensitive
                  Personal Data to infer characteristics about you. We do allow
                  certain third parties to collect information about the users
                  of our Services to provide valuable services to us, such as
                  fraud detection, reporting, and analytics. This may include
                  sharing information about your interactions with our Services,
                  including information searched for or viewed in connection
                  with our Services for the purposes of providing you with
                  information related to your searches, queries, or other
                  interactions with our Services.
                </p>
                <p className="mt-4" data-id="element-605" data-mp="3bcml5ca7myzs">
                  We and our third-party partners may use cookies and similar
                  technologies to collect usage and browser information about
                  how you use our website. We process the information collected
                  through such technologies, which may include or be combined
                  with Personal Data, to help operate certain features of our
                  website, to enhance your experience through personalization,
                  and to help us better understand the features of our website
                  that you and other users are most interested in. For more
                  information on how we use cookies, please consult our Cookie
                  Notice.
                </p>
              </div>
              <div className="pt-4" data-id="element-606" data-mp="32u2cdcb75p6">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-607" data-mp="81wvazf0llgs">
                  Interactive Features of our Websites
                </h2>
                <p data-id="element-608" data-mp="2nvdzoccgu28n">
                  To the extent we offer any public or group forums in
                  connection with our Services, such as newsfeeds, blogs,
                  message boards, chat or question functions, or similar tools
                  ("Interactive Features"), the posts or comments you make may
                  be public and viewed by others. You should use care before
                  posting information about yourself, including Personal Data.
                  Because these are public postings, you should have no
                  expectation of privacy or confidentiality in the content you
                  submit to Interactive Features in connection with the
                  Services. Your disclosure of any Personal Data through the
                  Interactive Features is at your own risk.
                </p>
              </div>
              <div className="pt-4" data-id="element-609" data-mp="26ifjln7p9j4q">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-610" data-mp="1iuec8hm9c8qw">
                  Service Providers and Third Parties
                </h2>
                <h3 className="font-poppins font-normal text-lg text-black mb-3" data-id="element-611" data-mp="1dv1h79l8fvd8">
                  Service Providers
                </h3>
                <p data-id="element-612" data-mp="xatcbf15cg3t">
                  Service providers or vendors (or processors) acting on our
                  behalf must execute agreements requiring them to maintain
                  confidentiality and to process Personal Data only to provide
                  the services to us and in a way that aligns with this Notice,
                  other applicable privacy notices, and as explicitly permitted
                  or required by applicable laws, rules, and regulations.
                </p>
                <p className="mt-4" data-id="element-613" data-mp="1l05kqcongk52">
                  A current list of HiddenMatter's service providers and
                  subprocessors, including those engaged in connection with the
                  Huwey platform, is available at{' '}
                  <a href="/subprocessors" className="text-black hover:text-lime transition-colors underline" data-id="element-614" data-mp="1v0ei3tudobm1">
                    hiddenmatter.ai/subprocessors
                  </a>
                  .
                </p>
                <h3 className="font-poppins font-normal text-lg text-black mt-6 mb-3" data-id="element-615" data-mp="3fg2w1tggfy8o">
                  Links to Other Websites
                </h3>
                <p data-id="element-616" data-mp="35ipunv30kldi">
                  Our Services may contain links to other websites,
                  applications, or services that are not owned or operated by
                  HiddenMatter. Such links do not imply an endorsement with
                  respect to any third party, any website, or the products or
                  services provided thereby. You should carefully review the
                  privacy policies and practices of other websites and services
                  as we cannot control and are not responsible for privacy
                  policies, notices, or practices of third-party websites,
                  applications, and services.
                </p>
              </div>
              <div className="pt-4" data-id="element-617" data-mp="2blfu9ruz15rb">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-618" data-mp="2bmh2loklre5c">
                  Your Rights Regarding Your Personal Data
                </h2>
                <p className="mb-4" data-id="element-619" data-mp="22khop54vwq6m">
                  Depending on where you live, you may have the following rights
                  with respect to some or all of your Personal Data:
                </p>
                <ul className="list-disc ml-6 space-y-2" data-id="element-620" data-mp="2ucfc8941tfb3">
                  <li data-id="element-621" data-mp="2ue05lvemms7d">
                    to request information about or explain whether, and how, we
                    process your Personal Data;
                  </li>
                  <li data-id="element-622" data-mp="2li0zad6zqgv5">
                    to request access to and a copy of your Personal Data,
                    including to provide your Personal Data directly to another
                    organization (called, in some locations, a right to data
                    portability);
                  </li>
                  <li data-id="element-623" data-mp="397d5d470u8t8">
                    to request that we correct or update your Personal Data;
                  </li>
                  <li data-id="element-624" data-mp="3ljfj3k733dtu">to request that we delete your Personal Data;</li>
                  <li data-id="element-625" data-mp="3llrypqpddc3q">
                    to request that we restrict, suspend, block, or to object to
                    or opt-out of the processing of your Personal Data,
                    including your sensitive Personal Data, including
                    withdrawing consent;
                  </li>
                  <li data-id="element-626" data-mp="3c86z8nx9mox">to appeal the denial of a request; and/or</li>
                  <li data-id="element-627" data-mp="8bkt1r6yypqg">
                    to lodge a complaint with the data protection authority in
                    your jurisdiction.
                  </li>
                </ul>
                <p className="mt-4" data-id="element-628" data-mp="i1xf5nufmqyp">
                  To make a request, submit a complaint about how we process
                  your Personal Data, or to appeal the denial of one of your
                  requests, please contact us using the information at the
                  bottom of this Notice. Even if you make a complaint to us, you
                  may also in some jurisdictions lodge a complaint with the
                  relevant privacy or data protection authority in your
                  location. Upon rejection of an individual rights request you
                  may also have the right to file a lawsuit in court in
                  accordance with the law.
                </p>
                <p className="mt-4" data-id="element-629" data-mp="36tg4lj8ms3ka">
                  We will not discriminate against you for exercising any of the
                  rights described above, although we may not be able to
                  continue to provide you with certain Services or it may
                  otherwise affect the way we are able to interact with you.
                </p>
                <p className="mt-4" data-id="element-630" data-mp="1lgwge17pyq1i">
                  We will make reasonable efforts to respond promptly to your
                  requests. We may, after receiving your request, require
                  additional information from you to honor your request and
                  verify your identity. Please be aware that we may be unable to
                  afford these rights to you under certain circumstances, such
                  as if we are legally prevented from doing so.
                </p>
              </div>
              <div className="pt-4" data-id="element-631" data-mp="3ndnhltnny7re">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-632" data-mp="3ncvnkn9psi38">
                  Safeguarding Personal Data
                </h2>
                <p data-id="element-633" data-mp="3ef34d80vgqak">
                  Consistent with applicable laws and requirements, HiddenMatter
                  has put in place physical, technical, and administrative
                  safeguards designed to protect Personal Data from loss,
                  misuse, alteration, theft, unauthorized access, and
                  unauthorized disclosure consistent with legal obligations and
                  industry practices. However, as is the case with all websites,
                  applications, products, and services, we unfortunately are not
                  able to guarantee security for data collected through our
                  Services. In addition, it is your responsibility to safeguard
                  any passwords, identification or ID numbers, or similar
                  individual information associated with your use of the
                  Services.
                </p>
              </div>
              <div className="pt-4" data-id="element-634" data-mp="3r6pszgwa44ag">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-635" data-mp="3mdd73eizible">
                  How Long Your Personal Data Will Be Kept
                </h2>
                <p data-id="element-636" data-mp="3hch1mwizihdv">
                  We generally retain Personal Data for as long as needed for
                  the specific purpose or purposes for which it was collected or
                  obtained, and as outlined in this Notice. In some cases, we
                  may be required to retain Personal Data for a longer period of
                  time as required by law or for other necessary or required
                  purposes. Whenever possible, we aim to de-identify or
                  anonymize your Personal Data or otherwise remove some or all
                  information that may identify you from records that we may
                  need to keep for periods beyond the specified retention
                  period. The criteria used to determine our retention periods
                  include: (i) the length of time we have an ongoing
                  relationship with you; (ii) whether there is a legal
                  obligation to which we are subject that affects the length of
                  time we need to keep your Personal Data; and (iii) whether
                  retention is determined to be necessary for HiddenMatter due
                  to limitation periods, litigation, or other legal or
                  regulatory obligations. HiddenMatter takes reasonable steps to
                  securely dispose of Personal Data upon the expiration of
                  retention periods, taking into consideration these litigation,
                  legal, or regulatory obligations.
                </p>
              </div>
              <div className="pt-4" data-id="element-637" data-mp="n67tp1f4lr0w">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-638" data-mp="i7myxhin7zju">
                  International Transfers of Personal Data
                </h2>
                <p data-id="element-639" data-mp="3qpj0s336mfza">
                  HiddenMatter operates exclusively in the United States and
                  does not target or market itself to persons outside of the
                  United States. If you are accessing the Services from a
                  foreign jurisdiction including, but not limited to, the
                  European Economic Area, the United Kingdom, or Switzerland,
                  your Personal Data may be transmitted to, stored, and
                  processed in the United States or other jurisdictions whose
                  laws are not as protective of Personal Data as the laws in
                  your jurisdiction. If you object to such processing, you
                  should cease using the Services.
                </p>
              </div>
              <div className="pt-4" data-id="element-640" data-mp="2jv3djilag6eh">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-641" data-mp="2os25pvle63a1">
                  Changes to this Privacy Notice
                </h2>
                <p data-id="element-642" data-mp="3ck0wlnxbq78a">
                  We reserve the right to change this Notice from time to time.
                  We will alert you when changes have been made by indicating
                  the date this Notice was last updated as the date the Notice
                  became effective or as otherwise may be required by law. It is
                  recommended that you periodically revisit this Notice to learn
                  of any changes.
                </p>
              </div>
              <div className="pt-4" data-id="element-643" data-mp="43fijspu4nyb">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-644" data-mp="204zf1hmpxj9y">
                  Contact Us
                </h2>
                <p data-id="element-645" data-mp="1vdr6ent7q1xu">
                  If you have any questions about our practices or this Privacy
                  Notice, please contact us at{' '}
                  <a href="mailto:chat@hiddenmatter.ai" className="text-black hover:text-lime transition-colors underline" data-id="element-646" data-mp="1lgmrn91p58r2">
                    chat@hiddenmatter.ai
                  </a>{' '}
                  or by phone at +1 774 286-9899.
                </p>
              </div>
            </div>
          </div>
        </Section>
      </main>
      <Footer data-id="element-647" data-mp="254m36m434jxj" />
    </div>;
}